export const FilterSeparator = () => {
    return (
        <div className="mx-3 h-7.5 shrink-0 border-l border-[#C8C8CA]"></div>
    );
};
